import {
  MfaOriginProductModel,
  TwoFactorTypes,
} from '../../models/user-profile.model';

export interface MfaState {
  isLoading: boolean;
  hasFailed: boolean;
  errorType?: MfaErrors;
  twoFactorType: TwoFactorTypes;
  originProduct: MfaOriginProductModel;
}

export const initialMfaState: MfaState = {
  isLoading: false,
  hasFailed: false,
  twoFactorType: TwoFactorTypes.NONE,
  originProduct: {
    code: null,
    userid: null,
    email: null,
    loginUrl: null,
  },
};

export enum MfaErrors {
  IS_QR_CODE_FAIL = 'isQrCodeFail',
  IS_TIMED_OUT = 'isTimedOut',
  IS_EMAIL_MISSING = 'isEmailMissing',
  DEFAULT = 'default',
}
